export default [
    {
      path: '/admin/product-pallets',
      name: 'product-pallet',
      meta: { requiresAuth: true },
      component: () => import('@/pages/product/pallet')
    },
    {
      path: '/admin/product-pallets/edit',
      name: 'product-pallet-edit',
      meta: { requiresAuth: true },
      component: () => import('@/pages/product/pallet/edit.vue')
    }
]